import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'semantic-ui-react';

import styles from './table.module.css';

const PageSelector = ( {
	gotoPage,
	pageCount,
	value
} ) => {
	const handleChange = ( e, { value } ) => {
		gotoPage( parseInt( value ) - 1 );
	};

	return (

		<div className={ styles.pageSelector }>
			<span>Page&nbsp;</span>
			<Input
				className={ styles.pageInput }
				onChange={ handleChange }
				size="mini"
				type="number"
				value={ value }
			/>
			<span>&nbsp;{ `of ${ pageCount }` }</span>
		</div>
	);
};

PageSelector.propTypes = {
	gotoPage: PropTypes.func.isRequired,
	pageCount: PropTypes.number.isRequired,
	value: PropTypes.string.isRequired
};

export default memo( PageSelector );
